import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Quet from './pages/Quet';
import './App.css';
import Fruskac from './pages/Fruskac';
import About from './pages/About';
import Contact from './pages/Contact';
import Map from './pages/Map';
import Fallback from './pages/Fallback';
import TermsAndConditions from './pages/TermsAndConditions';
import AppImages from './pages/AppImages';
import "@fontsource/raleway";
import TriSunca from './pages/TriSunca';
import { config } from './config';
import { buildLocalizedPath, getLanguageFromPath } from './i18n/routing';
import { LanguageCode } from './i18n/languages';

/** @todo novosti komponenta */
function App() {
  const location = useLocation();
  const fallbackLanguage = config.fallbackLanguage;

  const getLegacyRedirect = (pathname: string, language: LanguageCode): string | null => {
    if (pathname.startsWith('/quet-wine/')) {
      const quetWineName = pathname.replace('/quet-wine/', '').replace('.php', '');
      return buildLocalizedPath(`/quet/${quetWineName}`, language);
    }
    return null;
  };

  const languageFromPath = getLanguageFromPath(location.pathname);
  if (!languageFromPath) {
    const legacyRedirect = getLegacyRedirect(location.pathname, fallbackLanguage);
    const target = legacyRedirect || buildLocalizedPath(location.pathname, fallbackLanguage);
    return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
  }

  return (
    <Routes>
      <Route path="/:lang" element={<Home />} />
      <Route path="/:lang/trisunca/:id?" element={<TriSunca />} />
      <Route path="/:lang/quet/:id?" element={<Quet />} />
      <Route path="/:lang/fruskac/:id?" element={<Fruskac />} />
      <Route path="/:lang/about" element={<About />} />
      <Route path="/:lang/contact" element={<Contact />} />
      <Route path="/:lang/map" element={<Map />} />
      <Route path="/:lang/tc-reservations" element={<TermsAndConditions />} />
      {/* <Route path="/blogs" element={<Blogs />} /> */}
      <Route path="/:lang/appimagespreview" element={<AppImages />} />
      <Route path="/:lang/*" element={<Fallback />} />
    </Routes>
  );
}

export default App;
